import React, { memo } from "react"
import { getTranslation } from "../../scripts/getTranslation"

const Questions = memo(({ translations, language, questionRef }) => {
  return (
    <ul style={language === "ARB" ? { direction: "rtl" } : {}}>
      <li style={language === "ARB" ? { direction: "rtl" } : {}}>
        {getTranslation(
          translations,
          language,
          "Questions",
          `${questionRef}-Q1`
        )}
      </li>
      <li>
        {getTranslation(
          translations,
          language,
          "Questions",
          `${questionRef}-Q2`
        )}
      </li>
      <li>
        {getTranslation(
          translations,
          language,
          "Questions",
          `${questionRef}-Q3`
        )}
      </li>
      <li>
        {getTranslation(
          translations,
          language,
          "Questions",
          `${questionRef}-Q4`
        )}
      </li>
    </ul>
  )
})

export default Questions
